import React from 'react'

function Footer() {
    return (
        <>
            <footer className="main-footer d-flex p-2 px-3 bg-white border-bottom">
                <span className="copyright ml-auto my-auto mr-2">
                    Copyright © Programa Mentoring 2020{" "}
                </span>
            </footer>
        </>
    )
}

export default Footer
